export const COLUMNS_IDS = {
  action: "Action",
  more_info: "More Info",
  status: "Status",
  type: "Type",
  name: "Name",
  totalPrice: "Total Price",
};

export const headers = [
  "Type",
  "Name",
  "Company/Vendor",
  "More Info",
  "Student Pays",
  "Institution Pays",
  "Total Price",
  "Upgrade/Discont",
  "Status",
  "Action",
];

export const ORDER_STATUSES = {
  Unfulfilled: "Unfulfilled",
  Fulfilled: "Fulfilled",
  Canceled: "Canceled",
};

export const AVAILABLE_UPDATE_ORDER_STATUS = {
  Draft: ["Draft", "Submitted", "Paid, Confirmed", "Withdrawn"],
  Submitted: ["Submitted", "Paid, Confirmed", "Withdrawn"],
  "Paid, Confirmed": ["Paid, Confirmed", "Fulfilled", "Submitted", "Withdrawn"],
  Fulfilled: ["Paid, Confirmed", "Fulfilled", "Withdrawn"],
  Withdrawn: ["Submitted", "Paid, Confirmed", "Withdrawn"],
};

export const ORDER_CONTRACT_SAVE_ERROR_MSG =
  "Unable to save. The contract number or ope_id is invalid for this institution.";

export const ORDER_CONTRACT_SAVE_SUCCESS_MSG = "Order contract saved successfully.";

export const ORDER_CONTRACT_SAVE_SUCCESS_MSG_NO_INVOICE =
  "Home Institution and contract number were successfully saved. No updates were made to the invoice.";

export const LAST_TIME_UPDATED_LITERAL = "Last Time Updated";

export const EXCURSION_INCLUDED_TEXTS = {
  included: "Included",
  addon: "Add on",
  notAvailable: "Not Available",
};

export const MEETING_POINT_SECTION_KEYS = {
  meetingPointName: "Meeting Point Name",
  meetingPointAddress: "Meeting Point Address",
  instructions: "Meeting Point Instructions",
  edit: "Edit",
};
